import { useTranslation } from 'react-i18next';
import Button from 'common/components/button/Button';
import { BulkContractsCommitResult } from 'api/contracts/bulk/models/BulkContractsModels';
import styles from '../BulkContractsScreen.module.scss';

type Props = {
    result: BulkContractsCommitResult;
    onGoToListing: () => void;
    onStartOver: () => void;
};

// Task #66347: resumo do que foi gravado. As linhas que falharam ficam listadas com o número da
// linha da grelha, para o utilizador saber exatamente o que voltar a tratar.
const BulkContractsResultPanel = ({ result, onGoToListing, onStartOver }: Props) => {
    const { t } = useTranslation();

    return (
        <div className={styles.resultPanel}>
            <div className={styles.resultCounters}>
                <div className={styles.resultCounter}>
                    <span className={styles.resultCounterValue}>{result.created}</span>
                    <span>{t('bulk_contracts.result.created')}</span>
                </div>
                <div className={styles.resultCounter}>
                    <span className={styles.resultCounterValue}>{result.updated}</span>
                    <span>{t('bulk_contracts.result.updated')}</span>
                </div>
                <div className={styles.resultCounter}>
                    <span className={styles.resultCounterValue}>{result.failed?.length ?? 0}</span>
                    <span>{t('bulk_contracts.result.failed')}</span>
                </div>
            </div>

            {!!result.failed?.length &&
                <ul className={styles.resultFailures}>
                    {result.failed.map(failure => (
                        <li key={failure.line}>
                            <b>{t('bulk_contracts.result.line', { line: failure.line })}:</b> {failure.message}
                        </li>
                    ))}
                </ul>}

            <div className={styles.resultActions}>
                <Button preset={'secondary'} onClick={onStartOver} text={t('bulk_contracts.result.start_over') as string} />
                <Button onClick={onGoToListing} text={t('bulk_contracts.result.go_to_listing') as string} />
            </div>
        </div>
    );
};

export default BulkContractsResultPanel;
